var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonLink, Trans } from '@lucidlink/uicore';
import { workspaceRoutes } from '@lucidlink/workspacemanagement';
export const BillingPlansLink = ({ kind = 'secondary', shortButtonText, size, workspaceId, }) => {
    return (_jsx(ButtonLink, { "data-testid": "billing-plans", kind: kind, ...(size && { size }), to: workspaceRoutes.workspaceSettingsBillingPlans(workspaceId), children: shortButtonText ? (_jsx(Trans, { children: "Upgrade" })) : (_jsx(Trans, { children: "Upgrade plan now" })) }));
};
_react_refresh_temp_1 = BillingPlansLink;
$RefreshReg$(_react_refresh_temp_1, "BillingPlansLink");
